import React from 'react';
import { Hourglass, GitBranch } from 'lucide-react';

export const QueueCallbacksCard = ({ callbacks, cardBg, cardBorder, textPrimary, textSecondary, subtleBg }) => {
  const rows = (callbacks || []).filter(cb => cb.source === 'ivr_queue' && cb.status === 'queued')
    .sort((a, b) => (a.queue_position || 0) - (b.queue_position || 0));
  return (
    <div className={`${cardBg} backdrop-blur-xl rounded-2xl border ${cardBorder} p-4`} data-testid="queue-callbacks-card">
      <div className={`text-[10px] font-bold tracking-widest ${textSecondary} mb-3 flex items-center gap-1.5`}>
        <Hourglass size={11} className="text-amber-400" />SAVED PLACES IN LINE
      </div>
      {rows.length === 0 ? <div className={`text-xs ${textSecondary} py-2 text-center`}>No callers waiting for a callback</div> : (
        <div className="space-y-1.5">
          {rows.map(cb => (
            <div key={cb.call_id} className={`flex items-center gap-2.5 p-2 rounded-lg ${subtleBg}`} data-testid={`queue-callback-${cb.call_id}`}>
              <div className="w-8 h-8 rounded-lg bg-amber-400/15 text-amber-400 flex items-center justify-center text-xs font-bold flex-shrink-0" data-testid={`queue-callback-position-${cb.call_id}`}>#{cb.queue_position || '—'}</div>
              <div className="flex-1 min-w-0">
                <div className={`text-xs font-semibold ${textPrimary} truncate`}>{cb.contact_name || cb.contact_phone}</div>
                <div className={`text-[10px] ${textSecondary} truncate flex items-center gap-1`}>
                  <GitBranch size={9} />{cb.routing_flow_name || 'Call flow'} · {cb.agent_name || 'IVR agent'}
                </div>
              </div>
              {cb.scheduled_at && <div className={`text-[10px] ${textSecondary} text-right flex-shrink-0`}>est.<br />{new Date(cb.scheduled_at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QueueCallbacksCard;
